import React from 'react';

import Section from 'Elements/Section';

import Grid, { Col } from 'Components/Grid';

import MediaHubSectionNav, { MediaHubSectionNavProps } from 'Modules/SectionNavigation/MediaHub';

import { Heading, SectionNavWrapper, WaveWrapper, Wave } from './MediaHub.styled';

export interface Props {
    heading: string;
    sectionNav: MediaHubSectionNavProps;
}

const MediaHub: React.FC<Props> = props => {
    const { heading, sectionNav } = props;

    return (
        <Section id="hero" background overflow="hidden">
            <WaveWrapper>
                <Wave />
            </WaveWrapper>
            <Grid>
                <Col b={12} m={6}>
                    <Heading>{heading}</Heading>
                </Col>
                <Col b={12} m={6}>
                    <SectionNavWrapper>
                        <MediaHubSectionNav {...sectionNav} />
                    </SectionNavWrapper>
                </Col>
            </Grid>
        </Section>
    );
};

export default MediaHub;
